import {cartRegister} from "./cartRegister";
import queryString from "query-string";
import {dataRegister} from "./dataRegister";
import {imagesRegister} from "./imagesRegister";
import {themeRegister} from "./themeRegister";
import {salesChannelRegister} from "./salesChannelRegister";
const hash = require('object-hash');

class videoRegisterNew {

    static video = {hash: null, url: null, thumbnail: null};
    static custom = {url: null, thumbnail: null};

    static setCustom(url, thumbnail){
        videoRegisterNew.custom.url = url;
        videoRegisterNew.custom.thumbnail = thumbnail;
    }

    static getCustom(){
        return videoRegisterNew.custom;
    }

}

export {videoRegisterNew}


// WEBPACK FOOTER //
// ./src/services/videoRegisterNew.js